export function preventDefaults(evt: React.SyntheticEvent) {
  evt.preventDefault()
  evt.stopPropagation()
}

export function ifKeyDown<E extends HTMLElement>(
  keys: string | string[],
  callback: (event: React.KeyboardEvent<E>) => void
) {
  if (typeof keys === 'string') keys = [keys]

  return (evt: React.KeyboardEvent<E>) => {
    if (keys.includes(evt.key)) callback(evt)
  }
}

/**
 * Check if a number is between two other numbers (inclusive)
 * @param num Number to check
 * @param min Minimum (inclusive)
 * @param max Maximum (inclusive)
 */
export function isBetween(num: number, min: number, max: number) {
  if (min > num || max < num) return false
  return true
}
